import { getLoginUrl } from './url';

export function handleGraphQLError(response: Response) {
  if (response.status === 403) {
    location.replace(getLoginUrl());
  }
}
